import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function PopularDestinations({ limit }) {
    const [destinations, setDestinations] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchDestinations = async () => {
            try {
                const res = await axios.get("https://hotel.southtravels.com/api/destinations");
                setDestinations(res.data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchDestinations();
    }, []);

    return (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8 sm:mb-10">
                <div>
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800">
                        Popular Destinations
                    </h2>
                    <p className="text-sm sm:text-base text-gray-500 mt-2">
                        Explore the most loved destinations
                    </p>
                </div>

                {/* Desktop Button */}
                <button
                    onClick={() => navigate("/destinations")}
                    className="hidden sm:inline-flex bg-gray-900 text-white px-5 py-3 rounded-lg hover:bg-gray-800 transition text-sm sm:text-base"
                >
                    View All
                </button>
            </div>

            {/* Loading */}
            {loading ? (
                <div className="flex justify-center py-10">
                    <div className="animate-spin h-10 w-10 border-4 border-teal-500 border-t-transparent rounded-full"></div>
                </div>
            ) : (
                <>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
                        {destinations.slice(0, limit).map((dest) => (
                            <div
                                key={dest.id}
                                onClick={() => navigate(`/destinations/${dest.slug}`)}
                                className="relative h-56 sm:h-64 md:h-72 lg:h-64 rounded-2xl overflow-hidden cursor-pointer group shadow-md hover:shadow-xl transition"
                            >
                                {/* Image */}
                                <img
                                    src={`https://hotel.southtravels.com/uploads/destinations/${dest.image}`}
                                    alt={dest.name}
                                    className="w-full h-full object-cover group-hover:scale-110 transition duration-500"
                                />

                                {/* Overlay */}
                                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>

                                {/* Content */}
                                <div className="absolute bottom-4 left-4 right-4 text-white">
                                    <h3 className="text-lg sm:text-xl font-bold line-clamp-1 text-white">
                                        {dest.name}
                                    </h3>
                                    <p className="text-sm sm:text-base opacity-90">
                                        {dest.hotels_count} Hotels
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Mobile Button */}
                    <div className="mt-8 sm:hidden">
                        <button
                            onClick={() => navigate("/destinations")}
                            className="w-full bg-gray-900 text-white px-5 py-3 rounded-lg hover:bg-gray-800 transition text-sm"
                        >
                            View All
                        </button>
                    </div>
                </>
            )}
        </section>
    );
}